import React from 'react'
import { TextField, FormControl, FormHelperText, MenuItem, Box } from '@material-ui/core'
import { styled } from '@material-ui/styles'

export default function CustomInput(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const {
    label,
    type,
    placeholder,
    className,
    error,
    errorHelp,
    fullWidth,
    value,
    select,
    options,
    onChange,
    fieldProps
  } = props

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <FormControl error={error} fullWidth={fullWidth}>
      <TextField
        select={select}
        variant="outlined"
        label={label}
        type={type}
        placeholder={placeholder}
        className={className}
        error={error}
        value={value}
        onChange={onChange}
        {...fieldProps}
      >
        {select &&
          options.map(option => (
            <StyledMenuItem key={option.label} value={option.value}>
              {option.default ? <em>{option.label}</em> : option.label}
            </StyledMenuItem>
          ))}
      </TextField>
      {error && errorHelp ? (
        <Box mb={2}>
          <FormHelperText error={error}>{errorHelp}</FormHelperText>
        </Box>
      ) : (
        <Box mb={2}></Box>
      )}
    </FormControl>
  )
}

/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
CustomInput.defaultProps = {
  label: '',
  type: 'text',
  placeholder: '',
  className: '',
  errorHelp: '',
  options: [],
  onChange: () => {}
}

/**
|--------------------------------------------------
| Menu Item Styles
|--------------------------------------------------
*/
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  margin: `0 ${theme.spacing(1)}px`
}))
